import axios from "axios";
import React, { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./css/main.login.css";
import Register from "../register/Register";
import BackgroundVideo from "components/BackgroundVideo";

const Login: React.FC = () => {
  const Cookies = require("js-cookie");
  const navagate = useNavigate();

  const [isShowLoginForm, setIsShowLoginForm] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [modalStatus, setModalStatus] = useState(false);

  const handleLogin = async () => {
    const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    if (userName.trim() === "" || password.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    } else if (userName.trim() != "" || password.trim() != "") {
      try {
        Swal.fire({
          title: "Đang xử lý...",
          text: "Vui lòng đợi giây lát",
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        // Chờ 3 giây
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await axios
          .post(`${process.env.REACT_APP_URL_API}/auth/login`, {
            username: userName,
            password,
          })
          .then(async (data) => {
            localStorage.setItem(
              "user_info",
              JSON.stringify({
                userName: data.data.user.username,
                coins: data.data.user.coins,
                role: data.data.user.role,
                id: data.data.user._id,
              }),
            );

            Cookies.set("access_token", data.data.access_token, {
              expires: 1 / 24,
              secure: false, // Thử false cho iOS
              sameSite: "Lax", // Thử Lax thay vì Strict
            });

            await new Promise((resolve) => setTimeout(resolve, 100));

            if (
              data.status === 201 &&
              (data.data.user.role === "SUPERADMIN" ||
                data.data.user.role === "ADMIN")
            ) {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              setTimeout(() => {
                window.location.href = "/admin";
              }, 500);
            } else {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                text: "Vui lòng đợi ít phút. ",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              setTimeout(() => {
                window.location.href = "/";
              }, 500);
            }
          })
          .catch((err) => {
            if (err.status === 401) {
              Swal.fire({
                icon: "error",
                title: "Lỗi đăng nhập",
                text: "Tài khoản/mật khẩu không chính xác!",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
            }
          });
      } catch (error) {
        return error;
      }
    }
  };

  return (
    <>
      <div className="login-page">
        <BackgroundVideo />
        {/*  */}
        <div
          className={`model-group ${
            isShowLoginForm || isRegister || isLogin ? "active" : ""
          }`}
        >
          <div className="overlay"></div>

          {/* LOGIN MODAL */}
          <div className={`${isLogin ? "block" : "hidden"}`}>
            <img
              src="/assets/bg-login-modal.png"
              className="md:w-[530px] md:h-[363px] w-[400px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0"
              alt="bg-login-modal.png"
            />
            <div className="z-10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              {/* btn x */}
              <button
                onClick={() => {
                  setIsShowLoginForm(false);
                  setIsLogin(false);
                }}
                className="absolute md:right-0 right-[-50%]"
              >
                <img src="/assets/btn-x.png" alt="Thoát" />
              </button>
              <form
                id="loginform"
                onSubmit={handleLogin}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                className="mt-8 md:w-[530px] md:h-[363px]"
              >
                <p className="text-white font-medium  text-center md:mb-8 mb-5">
                  ĐĂNG NHẬP
                </p>
                <div className="grid grid-cols-1 place-items-center w-full gap-2">
                  <input
                    className="p-1 md:mb-3 mb-1 rounded-md md:w-[80%] w-full custom-input"
                    type="text"
                    id="txtUsername"
                    placeholder="Nhập tên tài khoản"
                    onChange={(e) => setUserName(e.target.value)}
                    maxLength={16}
                    minLength={4}
                    autoComplete="off"
                    required
                  />
                  <input
                    className="p-1 md:mb-3 mb-1 rounded-md md:w-[80%] w-full custom-input"
                    type="password"
                    id="txtPassword"
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Nhập mật khẩu"
                    maxLength={16}
                    minLength={4}
                    autoComplete="off"
                    required
                  />
                </div>
                <div className="mt-4 flex justify-center gap-x-2">
                  <button
                    type="button"
                    className="filter transition duration-300 hover:brightness-125 hover:contrast-110"
                    onClick={() => {
                      setIsShowLoginForm(false);
                      setIsLogin(false);
                    }}
                  >
                    <img src="/assets/btn-cancel.png" alt="Huỷ" />
                  </button>
                  <button
                    type="button"
                    className="filter transition duration-300 hover:brightness-125 hover:contrast-110"
                    onClick={handleLogin}
                  >
                    <img src="/assets/btn-done.png" alt="Xác Nhận" />
                  </button>
                </div>
                <p className="txt-swith text-center mt-3  text-[#ffffff99] md:mb-0 mb-12">
                  Chưa có tài khoản?{" "}
                  <button
                    className="underline inline font-medium text-white text-lg"
                    onClick={() => {
                      // setIsShowLoginForm(false);
                      setIsLogin(false);
                      setIsRegister(true);
                    }}
                  >
                    Đăng ký ngay
                  </button>
                </p>
              </form>
            </div>
          </div>

          {/* REGISTER MODAL */}
          <Register
            isRegister={isRegister}
            setIsShowLogin={() => setIsLogin(true)}
            setIsRegister={() => setIsRegister(false)}
          />
        </div>
        {/* MAIN */}
        <div
          className={`py-6 ${
            isLogin || isRegister ? "hidden" : "block"
          } md:px-0 px-5`}
        >
          {/* top */}
          <div className="flex justify-center items-center  md:mb-0 mb-7">
            <img src="/assets/login-banner.png" alt="Banner" />
          </div>
          {/* central */}
          <div className="md:pr-7 md:pl-[78px] md:mb-0 mb-3 flex md:flex-row flex-col-reverse justify-center items-center">
            {/* left */}
            <div className="md:block flex">
              <img
                className="md:w-full w-3/4 h-auto"
                src="/assets/robot.png"
                alt="Robot"
              />
              <div className="md:hidden flex flex-col gap-5">
                <a
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/profile.php?id=61550584611151"
                  target="_blank"
                >
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
                <a
                  href="https://t.me/CONGBINH2026"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/assets/tele.png" alt="Telegram" />
                </a>
              </div>
            </div>

            {/*   button group*/}
            <div className="flex flex-col md:gap-7 gap-3 items-center justify-center mt-5 md:mt-0">
              <div className="flex justify-center items-center gap-6">
                <button
                  onClick={() => {
                    setIsShowLoginForm(true);
                    setIsLogin(true);
                  }}
                  className="btn-hover"
                >
                  <img src="/assets/btn-login2.png" alt="Đăng nhập" />
                </button>
                <button
                  onClick={() => {
                    setIsRegister(true);
                  }}
                  className="btn-hover"
                >
                  <img src="/assets/btn-register2.png" alt="Đăng ký" />
                </button>
              </div>

              <button className="btn-hover md:w-auto md:h-auto w-[160px] h-[60px] md:mb-0 mb-4">
                <img src="assets/btn-down-tool.png" alt="Tải app" />
              </button>
              <img
                className="md:block hidden"
                src="/assets/login-list-game.png"
                alt="Danh sách trò chơi"
              />
            </div>
            {/* right */}
            <div className="md:flex flex-col items-center justify-center">
              <div className="flex flex-col">
                <img src="/assets/login-card.png" alt="Thẻ game" />
              </div>
              <div className="hidden md:flex mt-[62px] items-center justify-end w-full ">
                <div className="flex flex-col items-center gap-[46px]">
                  <a
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/profile.php?id=61550584611151"
                    target="_blank"
                  >
                    <img src="/assets/facebook.png" alt="Facebook" />
                  </a>
                  <a
                    href="https://t.me/CONGBINH2026"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/assets/tele.png" alt="Telegram" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* bottom */}
          <div className="flex flex-col items-center justify-center">
            <img
              className="md:hidden mb-3"
              src="/assets/login-list-game.png"
              alt="Danh sách trò chơi"
            />
            <img src="/assets/login-bottom1.png" alt="Danh sách trò chơi" />
            <img src="/assets/link-down-app.png" alt="Link truy cập tải" />
          </div>
        </div>
        ;
      </div>
    </>
  );
};

export default Login;
